export default __webpack_public_path__ + "static/media/whitedown.ee1ba880.svg";